var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm._m(0);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('footer', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "footer-top"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "footer-link-wrap"
  }, [_c('ul', {
    staticClass: "footer-link"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "/company"
    }
  }, [_vm._v("회사소개")])]), _c('li', [_c('a', {
    attrs: {
      "href": "/policy"
    }
  }, [_vm._v("이용약관")])]), _c('li', [_c('a', {
    attrs: {
      "href": "/privacy"
    }
  }, [_vm._v("개인정보 취급방침")])]), _c('li', [_c('a', {
    attrs: {
      "href": "/company#green"
    }
  }, [_vm._v("친환경벽지")])])])]), _c('ul', {
    staticClass: "footer-right"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_vm._v("design id DID")])])])])]), _c('div', {
    staticClass: "footer-bottom"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "footer-col"
  }, [_c('ul', {
    staticClass: "footer-info"
  }, [_c('li', [_vm._v("서울특별시 강남구 봉은사로 327(논현동) 궁도빌딩 10-13층")]), _c('li', [_vm._v("대표번호 02-2141-3930")]), _c('li', [_vm._v("이메일 customer@didwallpaper.com")]), _c('li', [_vm._v("사업자등록번호 220-85-09219")]), _c('li', [_vm._v("Copyright (c) 2020 didwallpaper all right reserved.")])])])])])]);

}]

export { render, staticRenderFns }